
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`This is brought by the
                    <a href="${0}">Folksonomy Engine project</a>. Don't
                    hesitate to participate or give feedback`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`To orodje vam omogoča popravljanje seznama sestavin. Dodate, odstranite ali uredite lahko
                seznam sestavin.
                <br>
                Ta znak <span class="highlight">␣</span> predstavlja presledek.
                <br>
                Ta znak <span class="highlight">↩︎</span> predstavlja prelom vrstice. `,
'hb28f1f2ec1744ee9': html`Te lastnosti ustvarijo in shranijo uporabniki za kakršno koli uporabo. Dodajte svoje
                    . Lastnosti in vrednosti, ki jih ustvarite
                    <strong>, morajo biti dejanske</strong>. Lahko se poglobite v
                    <a href="${0}">seznam lastnosti, ki jih skupnost že uporablja</a>
                    ali pa raziščete dokumentacijo lastnosti
                    <a href="${1}">in njen iskalnik</a>.`,
's000a5b76bd3a01c2': `Nalaganje lastnosti ...`,
's000d98595e959c1e': `Pridobite ga v Googlu Play`,
's013bdc8cf0d3583d': `Pomagajte nam s sestavinami`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Potrdite pridelek`,
's03e9c8114521b998': `Sestavine bom uredil/a`,
's05ec315d9308091a': `Ikona vogalov črtne kode`,
's061eb5af92512c85': `Shranjeno! Mi lahko pomagate še z enim?`,
's06847c221c4c0bc1': `Rad bi ustvaril lastnost za [opišite svoj primer uporabe] ...`,
's06f6c6f99db6b552': `Izvirnik`,
's081e2ad82db71e1d': `Združene vrednosti`,
's09205907b5b56cda': `Ne`,
's0b4235aae602a950': `namenska dokumentacija`,
's0bb2d48532acc455': `Prenesi CSV`,
's0d5b7fee0311db68': `Nepremičnina`,
's0fb218abc2e157ed': `Razveljavi sliko`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Prekliči obrezovanje`,
's11a18a69b30b65ed': `Pomagajte nam popraviti napake na seznamu sestavin`,
's1205d5f6fccf8e69': `Vrednost nepremičnine`,
's15d64a0a6715285a': `Nov ključ`,
's166bd56d19670a72': `Povečava`,
's19059bf0c4f7c162': `Območje izbire`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Pomagajte nam popraviti prehranske podatke`,
's1e00019dc454872d': `Prosimo, navedite ime lastnosti z uporabo atributa \`property-name\`.`,
's1e49126af0935a5b': `Seznam izdelkov, ki uporabljajo to lastnost`,
's21e73088de6f26f3': `Prenesi iz App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Prekliči`,
's2db7b654c0a9bde0': `Dokumentirajte nepremičnino`,
's300b3a6ee4e1252d': str`Slabo ujemanje ${0}%`,
's33f786bb6b4f0cf4': `Rezultat obrezovanja`,
's33f85f24c0f5f008': `Shrani`,
's34be4af4e8fec4ae': `Najprej vprašajte skupnost`,
's36d86adc823cbfa6': `Preden ustvarite novo nepremičnino, se o njej pogovorite s skupnostjo:`,
's3781d25aa51a736c': `Dokumentacija programa Folksonomy`,
's383ae4449428b61e': `Ponastavi obrezovanje`,
's39bcf88721a1e8ee': `Ponastavi izbiro`,
's39e14e14300694c7': `Dokumentacija in smernice`,
's3b430cfa5c1fe7f4': str`Dokumentacija za ${0}`,
's3f4e4b52f230a892': `Slikovno platno`,
's417b90913e05bc17': `Predogled`,
's41f7dca46d3f1b4a': `Vrednost`,
's422bba9636ce2489': `Sredinska slika`,
's42dd66b2441566fd': `Ikona središča`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Dodaj hranilo`,
's453ab0dbb9b5c777': `Spremeni velikost desno`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Število izdelkov`,
's4df2f533c0c1e7d0': `Kontrolniki slik`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Premakni izbor`,
's4f751fb9b3ed766c': `Ustvarjanje nove nepremičnine`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Vnesite ime nepremičnine ...`,
's55d7249883a98ca1': `o tej nepremičnini na wikiju Open Food Facts`,
's565867d84c04aea2': `Filtriraj lastnosti ...`,
's5666afe5cd0166de': `Pred potrditvijo popravite napake ali spremenite besedilo.`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Nalaganje izdelkov ...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Pomagajte nam popraviti prehranske podatke.`,
's5dd6f12783fca34f': `Uredi seznam sestavin`,
's5e8250fb85d64c23': `Zapri`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Uredi`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Hvala za vaš prispevek!`,
's6cee7cad81dfedd1': `Obrezana slika`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Dobro ujemanje ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Dokumentacija`,
's787dd11bed0dc88a': `Spremeni velikost levo`,
's7ce4fd9430e80cea': `vrednost`,
's801a05fa8e881f37': `Več o ustvarjanju nepremičnin in smernicah:`,
's8038273de2cf8b73': `Izberite območje za obrezovanje.`,
's839cc2908a5387f2': `Filtriraj črtne kode ...`,
's86197dcf3e96af64': `Brskajte in iščite obstoječe nepremičnine`,
's8a63be30a129a59c': `Spremeni velikost dna`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Spremeni velikost zgoraj desno`,
's8db84aa4bc949af2': `Dokumentirajte novo nepremičnino`,
's8f839a03997a16d7': `Ogled izdelka`,
's901ae1e236ac45d3': `Prekliči brisanje`,
's907f7a97c6b29425': `Upoštevajte, da se lahko podatkovni model spremeni. Uporabljate ga na lastno odgovornost.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Sestavine:`,
's9a7f60fce090ecaf': `Nalaganje lastnosti ni uspelo. Poskusite znova pozneje.`,
's9b87abd68fb9df45': `Niste našli? Ustvarite nov ključ {value}`,
's9c0f52425fd2f07e': `Morda se ne ujema`,
's9fc41f789c63b40d': `Izdelki`,
'sa1fa766e0d5634d7': `Ni na voljo rezultatov`,
'sa548778b24054030': `Raziščite vse prispevane lastnosti iz projekta Folksonomy Engine. Te lastnosti zagotavljajo dodatne metapodatke in vpoglede v izdelke v zbirki podatkov Open Food Facts.`,
'sa63907958bd0ec4b': `Spremeni velikost zgornjega levega`,
'sa95b4224f685a36a': `Zapri modalno okno`,
'sab56a1d439576fd6': `Ikona predloga`,
'sac47ea2901d04c15': `Spremeni velikost spodaj levo`,
'sb125227d436c2925': `Poiščite svoj koncept nepremičnine v obstoječi bazi podatkov o nepremičninah:`,
'sb125568d43642e6f': `Odgovorite na vprašanja o izdelku.`,
'sb1c538e038f9b214': str`Zelo dobro ujemanje ${0}%`,
'sb28639570ff3b852': `seznam vseh nepremičnin`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Ko preverite, da vaša lastnost ne obstaja in se skupnost strinja, da je uporabna, jo morate najprej dokumentirati v wikiju.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `Za to nepremičnino ni bilo najdenih izdelkov.`,
'sb7f72e4c8a2d3357': `Filtriraj vrednosti ...`,
'sb8178320160f84ea': `Prikaži obrezovanje`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Vsa vprašanja so bila odgovorjena! Hvala za vašo pomoč!`,
'sbd9a0b2293b3cd3c': `Velikost obroka`,
'sbe472dc3c2685985': `Ustrezna vrednost`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Spremeni velikost vrha`,
'sc1c08d0cbcc3bd24': `Ne ujema se`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Predlagana rešitev`,
'sc681b137e8f604f7': `Confirm deletion`,
'sc6daf8a31883f8b9': `Premakni sliko`,
'sc895972c88d38ca5': `Lastnina Folksonomy`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Vrstice`,
'scb3b0671d7b7f640': `Nova vrednost`,
'scb489a1a173ac3f0': `Da`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Pridružite se razpravi o Slacku`,
'scdb6cad0b92721bf': `Ni najdenih nepremičnin.`,
'scf23a05631f93732': `Potrdi brisanje`,
'scfed2f270ef6a3aa': `Izberite območje`,
'sd1022bc1ef9204f7': `Povečljiva slika`,
'sd1077c055cf9ba6b': `Pomagajte nam potrditi seznam sestavin izdelka.`,
'sd698d21ddecba56b': `Živjo! Pomagate nam lahko izboljšati informacije o izdelku tako, da odgovorite na naslednja vprašanja:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Preverite, ali nepremičnina že obstaja`,
'sdbf806fefc584115': `Moral bi najti`,
'sdc673e73b5c13aea': `Izbriši`,
'sdc792b75f1edcaba': `Pomagajte nam popraviti črkovanje sestavin.`,
'sdca5deead576ceee': `Spremeni velikost spodaj desno`,
'sdcc2555c5dde524f': `Ali ste prepričani, da želite izbrisati ta element? Tega dejanja ni mogoče razveljaviti.`,
'se206feec7ec57b28': `na 100 g`,
'se419a9ab36987490': `Razveljavi`,
'se5127cf0f92e7e48': `Nasvet: najdete lahko tudi`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Predlagal bom boljšo letino`,
'seea3800e27baa686': `Posamezni izdelki`,
'sefaba4adc4ec9219': `Lastnosti Folksonomyja`,
'seffa8ca49175b5f0': `Prilagojene lastnosti`,
'sf44a6b3b232c28ea': str`Zamenjaj trenutno vrednost z ${0}`,
'sf4cd86a2f5ef2588': `Črtna koda izdelka`,
'sf57a61152168cc81': `Pomagajte nam popraviti zaznavanje sestavin`,
'sf88b90b8ba23871c': `Neznano ujemanje`,
'sf9aee319a006c9b4': `Dodaj`,
'sfacbbe968fa7d773': `Ime nepremičnine:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Ustrezna vrednost`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  